import { defineMessages } from 'react-intl';

const messages = defineMessages({
  fixed: {
    id: 'Fixed width table cells',
    defaultMessage: 'Fixed width table cells',
  },
  compact: {
    id: 'Make the table compact',
    defaultMessage: 'Make the table compact',
  },
  basic: {
    id: 'Reduce complexity',
    defaultMessage: 'Reduce complexity',
  },
  celled: {
    id: 'Divide each row into separate cells',
    defaultMessage: 'Divide each row into separate cells',
  },
  inverted: {
    id: 'Table color inverted',
    defaultMessage: 'Table color inverted',
  },
  striped: {
    id: 'Stripe alternate rows with color',
    defaultMessage: 'Stripe alternate rows with color',
  },
  defaultFieldset: {
    id: 'Default',
    defaultMessage: 'Default',
  },
  tableStyle: {
    id: 'tableStyle',
    defaultMessage: 'Table Style',
  },
  fields: {
    id: 'Fields',
    defaultMessage: 'Fields',
  },
  metadataSection: {
    id: 'Metadata Section',
    defaultMessage: 'Metadata Section',
  },
  field: {
    id: 'field',
    defaultMessage: 'Field',
  },
  showLabel: {
    id: 'showLabel',
    defaultMessage: 'Show label?',
  },
  hideInView: {
    id: 'hideInView',
    defaultMessage: 'Hide in view page?',
  },
  noFieldsSelected: {
    id: 'No fields selected',
    defaultMessage: 'No fields selected',
  },
  metadata: {
    id: 'Metadata',
    defaultMessage: 'Metadata',
  },
  simpleList: {
    id: 'Simple list',
    defaultMessage: 'Simple list',
  },
});

export default messages;
